import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { ApiService } from 'src/app/services/api.service';
import { CommonService } from 'src/app/services/common.service';
import { PopoverController, IonContent,NavController } from '@ionic/angular';
import { NgxSmartModalService } from 'ngx-smart-modal';
import { FormGroup, FormBuilder, Validators, NgForm } from '@angular/forms';
import { AlertController } from '@ionic/angular';
import * as uuid from 'uuid';

@Component({
  selector: 'app-m-quickscan',
  templateUrl: './m-quickscan.page.html',
  styleUrls: ['./m-quickscan.page.scss'],
})
export class MQuickscanPage implements OnInit {
  @ViewChild('f', { read: NgForm }) form: any;
  @ViewChild('content', { static: false }) private content: IonContent;

  @ViewChild("textarea") inputElement: ElementRef;
  @ViewChild('input') myInput ;
  object: any = {};
  quickScanForm: NgForm = null;
  expandTreeButtonIcon: string = "fas fa-folder-plus";
  showPage: boolean = false;
  category: string;
  treeExpand: boolean = false;
  treeSuggestionExpand: boolean = true;
  isNodeSelect: boolean = false;
  isSuggestionNodeSelect: boolean = false
  type: string = ''
  tempData: any = []
  selectedFiles: any = {}
  selectedSuggestionFiles: any = {}
  isShow: boolean = true;
  quickScanTree: any = ''

  quickScanId: string = ''
  count: number = 0
  questionCount: number = 0;
  answerCount: number = 0

  breadcrumbType: any = ''
  toggleQuickScanTooltip: string
  toggleSuggestionTooltip: string
  quickScan: any = {};
  QuickScanItemsSelected: any = []
  quickScanSection: any = {}
  quickScanSectionItemsSelected: any = []
  quickScanQuestion: any = {};
  quickScanQuestionItemsSelected: any = []
  //quickScanAnswer: any = {}
  quickScanAnswerItemsSelected: any = []

  breadcrumbs: any = []
  parentNodeLabel: string = ''

  isSaveBack: boolean = false


  isRadioOrDropDown: boolean = false

  dragNodeArray: any = []
  isChildPresent: boolean;
  quickScanData: any = {};

  public dataTypes: any = [];
  customDataTypes: any = [];
  // public suggestionList: Array<Select2OptionData> = [];
  public questionList: any = [];
  public sectionList: any = [];
  public helpTextList: any = [];

  moduleList: any = []
  originalModuleList: any = []
  documentList: any = [];
  faqList: any = [];
  standardDocumentList: any = [];
  previousRoute:boolean;
  moduleName:string = '';

  public resultList: any;



  quickScanDescription: any = '';
  quickScanName: any = '';
  questionNumber: any = '';
  suggestionList:any = [];
  items: any = []

  rightClickNode: any;

  changedQuestions = [];
  changedAnswers = [];
  changedSection = [];
  changedFollowupQuestions = [];
  submitted: boolean = false;

  suggestionTree: any = ''

  constructor(public alertController: AlertController,private navCtrl: NavController,private router: Router, private route: ActivatedRoute, private _apiService: ApiService, private formBuilder: FormBuilder, public _commonService: CommonService, private popoverController: PopoverController, public ngxSmartModalService: NgxSmartModalService) { }

  ngOnInit() {
    this.toggleQuickScanTooltip = this._commonService.getLocalTranslation('label-expandAll');
    this.toggleSuggestionTooltip = this._commonService.getLocalTranslation('label-collapseAll');
    this.resultList = [{
      'ResultTypeId': 'ResultType_OK',
      'Description': this._commonService.getLocalTranslation('label-ok')
    },
    {
      'ResultTypeId': 'ResultType_NOK',
      'Description': this._commonService.getLocalTranslation('label-nOk')
    },
    {
      'ResultTypeId': 'ResultType_Warning',
      'Description': this._commonService.getLocalTranslation('label-warning')
    }];
  }


  ionViewDidEnter() {
    //this.selectedFiles = {}
    this.quickScanId = this.route.snapshot.paramMap.get('id');
    this.getInfo()
    this.items = [];
    if(sessionStorage.routeFrom == "listPage"){
      this.previousRoute = true;
    }else{
      this.previousRoute = false;
    }


    this.changedQuestions = [];
    this.changedAnswers = [];
    this.changedSection = [];
    this.changedFollowupQuestions = [];
    this.category = 'quickscan'
  }

  async getInfo() {
    this.getDataTypes();
    this.getQuestionList();
    this.getHelpTextList();
    this.getSectionList();
    this.getModuleList();
    this.getFaq();
    this.getDocument();
    this.getStandardDocument();
    this.getSuggestionList();
    this.getDetail('quickscan', this.quickScanId);
    this.getSuggestionTree();
    this.getQuickScanTree();
  }


  ionViewDidLeave() {
    this.showPage = false;
    this.isNodeSelect = false;
    this.type = ''
    this.breadcrumbs = []
    this._commonService.dismiss();
    this.submitted = false;
  }

  async getQuickScanTree() {
    try {

      this._commonService.presentLoading();
      let res = await this._apiService.getQuickScanTree(this.quickScanId);
      this.quickScanTree = res.body;

      if (this.quickScanTree) {

        this.quickScanTree.forEach(element => {

          this.traverse(element);
        });
      }

      // let response = await this._apiService.getQuickScanDetail(this.quickScanId);
      // this.quickScan = response.body;

      if (this.selectedFiles.constructor === Object && Object.keys(this.selectedFiles).length === 0) {
        this.type = 'quickscan';
        this.breadcrumbType = this._commonService.getLocalTranslation('label-quickScans')
        this.isNodeSelect = true;
        this.breadcrumbs = []
        this.traverseParent(this.quickScanTree[0])
      } else {
        // if (this.selectedFiles.constructor === Array) {
        //   this.selectedFiles = this.selectedFiles[0]
        // }
        this.breadcrumbs = []
        this.traverseParent(this.selectedFiles[0])
        this.isNodeSelect = true;
        this.type = this.selectedFiles[0].type.toLowerCase()
        this.breadcrumbType = this.selectedFiles[0].type
        let id = null
        if (this.type == 'quickscan') {
          id = this.selectedFiles[0].QuickScanId
          this.breadcrumbType = this._commonService.getLocalTranslation('label-quickScans')
        } else if (this.type == 'quickscansection') {
          id = this.selectedFiles[0].QuickScanSectionId;

          this.breadcrumbType = this._commonService.getLocalTranslation('label-quickScanSection')
        } else if (this.type == 'quickscanquestion') {
          id = this.selectedFiles[0].QuickScanQuestionId
          this.breadcrumbType = this._commonService.getLocalTranslation('label-quickScanQuestion')
        } else if (this.type == 'quickscananswers'){
          id = this.selectedFiles[0].QuickScanAnswerId
          this.breadcrumbType = this._commonService.getLocalTranslation('label-quickScanAnswer')
        } else {
          id = this.selectedFiles[0].QuickScanQuestionId
          this.breadcrumbType = this._commonService.getLocalTranslation('label-followUpQuestion')
        }
        this.getDetail(this.type, id)
      }



      this.showPage = true;

      this._commonService.dismiss();

    } catch (error) {
      this._commonService.dismiss();
      this._commonService.log(error, this._commonService.ERROR);
    }
  }

  get f() { return this.quickScanForm.controls; }

  onNodeContextMenuSelect(event) {
    let newNode = document.querySelector('.isNode-new');
    if (newNode) newNode.classList.remove("isNode-new");
    if(this.category == 'quickscan'){


          this.rightClickNode = event.node
          this.selectedFiles = [];
          this.selectedFiles[0] = event.node;
          this.type = event.node.type.toLowerCase();
          // if(!this.selectedFiles[0].data) {
          //   this.selectedFiles[0].data = {};
          // }
          if (event.node.type.toLowerCase() == 'quickscan') {
            this.breadcrumbType = this._commonService.getLocalTranslation('label-quickScans');
            this.items = [
              { label: this._commonService.getLocalTranslation('label-addSection'), icon: 'fas fa-plus-circle', command: (event) => this.addNode(event) },
            ];
          }
          if (event.node.type.toLowerCase() == 'quickscansection') {
            this.breadcrumbType = this._commonService.getLocalTranslation('label-quickScanSection');
            this.items = [
              { label: this._commonService.getLocalTranslation('label-addQuestion'), icon: 'fas fa-plus-circle', command: (event) => this.addNode(event) },
              { label: this._commonService.getLocalTranslation('label-deleteSection'), icon: 'fas fa-trash', command: (event) => this.deleteNode(event) }
            ];
          }

          if (event.node.type.toLowerCase() == 'quickscanquestion') {
            this.breadcrumbType = this._commonService.getLocalTranslation('label-quickScanQuestion');
            this.items = [

              { label: this._commonService.getLocalTranslation('label-deleteQuestion'), icon: 'fas fa-trash', command: (event) => this.deleteNode(event) }
            ];
            let dataType = '';
            if(event.node.DataTypeId) {
              dataType = this.dataTypes.find(dt => dt.DataTypeId === event.node.DataTypeId).Name;
            }
            if ((dataType == 'DataType_MultiSelect' || dataType == 'DataType_RadioGroup' || dataType == 'DataType_SelectList')) {
              this.items.unshift({ label: this._commonService.getLocalTranslation('label-addAnswer'), icon: 'fas fa-plus-circle', command: (event) => this.addNode(event) })
            }

          }

          if (event.node.type.toLowerCase() == 'quickscananswers') {
            this.breadcrumbType = this._commonService.getLocalTranslation('label-quickScanAnswer');
            this.items = [
              { label: this._commonService.getLocalTranslation('label-deleteAnswer'), icon: 'fas fa-trash', command: (event) => this.deleteNode(event) }
            ];

            if (event.node.children && event.node.children.length == 0) {
              this.items.unshift({ label: this._commonService.getLocalTranslation('label-addFollowupQuestion'), icon: 'fas fa-plus-circle', command: (event) => this.addNode(event) })
            }
          }

          if (event.node.type.toLowerCase() == 'followquickscanquestion') {
            this.breadcrumbType = this._commonService.getLocalTranslation('label-followUpQuestion');
            this.items = [
              { label: this._commonService.getLocalTranslation('label-deleteFollowupQuestion'), icon: 'fas fa-trash', command: (event) => this.deleteNode(event) }
            ];
          }
    }else{
      this.selectedSuggestionFiles = [];
      this.selectedSuggestionFiles[0] = event.node;
      if(event.node.type =='parent'){
        this.items = [
          { label: this._commonService.getLocalTranslation('label-addSuggestion'), icon: 'fas fa-plus-circle', command: (event) => this.addNode(event) },
        ];
      }else{
        this.items = [
          { label: this._commonService.getLocalTranslation('label-deleteSuggestion'), icon: 'fas fa-trash', command: (event) => this.deleteNode(event) }
        ];
      }
    }
  }

  addNode(event) {

    if(this.category =='quickscan'){

      let newNode = document.querySelector('.isNode-new');
      if (newNode) newNode.classList.remove("isNode-new");
      this.selectedFiles[0].isNodeNew = false
      this.breadcrumbs = []
      console.log(event)
      this.quickScanSection = {}
      if (this.selectedFiles[0].type.toLowerCase() == 'quickscan') {

        let node = {
          "label": this._commonService.getLocalTranslation('label-newSection'),
          "QuickScanSectionId": uuid.v4(),
          "type": "QuickScanSection",
          "expandedIcon": "fa fa-folder-open",
          "collapsedIcon": "fa fa-folder",
          "iconColor": "black",
          "textColor": "black",
          "isNodeNew": true,
          "expandedIconDetail": "grid-outline",
          "collapsedIconDetail": "grid-outline",
          "parent": this.selectedFiles[0],
          "isNodeEnabled": true,
          "children": [],
          "QuickScanId": this.selectedFiles[0].QuickScanId,
          "newNode": true
        }
        node["Description"] = node.label;
        this.sectionList.push(node);
        // this.sectionList.sort((a, b) => {
        //   if (a.Description.toLowerCase() > b.Description.toLowerCase()) {
        //     return 1;
        // }
        // if (a.Description < b.Description) {
        //     return -1;
        // }
        // return 0;
        // })
        this.traverseParent(node);
        this.quickScanSection.Description = node.label;
        this.selectedFiles[0].children.push(node);
        this.selectedFiles[0].expanded = true;
        this.type = 'quickscansection';
        this.selectedFiles[0] = node;
        //this.onNodeSelect('', this.selectedFiles);
        this.breadcrumbType = this._commonService.getLocalTranslation('label-quickScanSection');
        //this.save();
      } else if (this.selectedFiles[0].type.toLowerCase() == 'quickscansection') {
        this.questionCount++;
        this.quickScanQuestion = {}
        let node = {
          "label": this._commonService.getLocalTranslation('label-newQuestion'),
          "QuickScanQuestionId": uuid.v4(),
          "type": "QuickScanQuestion",
          "expandedIcon": "fa fa-folder-open",
          "collapsedIcon": "fa fa-folder",
          "isNodeNew": true,
          "iconColor": "black",
          "textColor": "black",
          "expandedIconDetail": "help-circle-outline",
          "collapsedIconDetail": "help-circle-outline",
          "isNodeEnabled": true,
          "parent": this.selectedFiles[0],
          "children": [],
          "QuickScanSectionId": this.selectedFiles[0].QuickScanSectionId,
          "DataTypeId": null,
          "HelpTextId": null,
          "isHidden": "0",
          "newNode": true
        }
        node["Description"] = node.label;
        this.questionList.push(node);
        this.questionList.sort((a, b) => {
          if (a.Description.toLowerCase() > b.Description.toLowerCase()) {
            return 1;
        }
        if (a.Description < b.Description) {
            return -1;
        }
        return 0;
        })
        this.selectedFiles[0].children.push(node)
        this.traverseParent(node)
        this.isNodeSelect = true;
        this.selectedFiles[0].expanded = true
        this.type = 'quickscanquestion';
        this.quickScanQuestion.Description = node.label
        this.selectedFiles[0] = node;
        this.breadcrumbType = this._commonService.getLocalTranslation('label-quickScanQuestion');
        //this.save()
      } else if (this.selectedFiles[0].type.toLowerCase() == 'quickscanquestion') {
        this.answerCount++;
        //this.quickScanAnswer = {}
        let node = {
          "label": this._commonService.getLocalTranslation('label-newAnswer'),
          "QuickScanAnswerId": uuid.v4(),
          "type": "QuickScanAnswers",
          "expandedIcon": "fa fa-folder-open",
          "collapsedIcon": "fa fa-folder",
          "iconColor": "black",
          "isNodeNew": true,
          "textColor": "black",
          "expandedIconDetail": "chatbox-ellipses-outline",
          "collapsedIconDetail": "chatbox-ellipses-outline",
          "isNodeEnabled": true,
          "parent": this.selectedFiles[0],
          "children": [],
          "QuickScanQuestionId": this.selectedFiles[0].QuickScanQuestionId,
          "Description": this._commonService.getLocalTranslation('label-newAnswer'),
          "QuickScanSectionId": null,
          "NextQuickScanQuestion": null,
          "QuickScanSuggestionId": null,
          "ResultType": null,
          "ResultText": '',
          "newNode": true
        }
        this.selectedFiles[0].children.push(node);
        this.selectedFiles[0].expanded = true;
        this.traverseParent(node);
        this.isNodeSelect = true;
        this.type = 'quickscananswers';
        this.selectedFiles[0] = node;

        this.breadcrumbType = this._commonService.getLocalTranslation('label-quickScanAnswer');
        //this.save()
      } else if (this.selectedFiles[0].type.toLowerCase() == 'quickscananswers'){
        let datatypeId = this.dataTypes.find(x => x.Name == "DataType_Textbox") ? this.dataTypes.find(x => x.Name == "DataType_Textbox").DataTypeId : null;
        let node = {
          "label": this._commonService.getLocalTranslation('label-newFollowupQuestion'),
          "QuickScanQuestionId": uuid.v4(),
          "type": "FollowQuickScanQuestion",
          "expandedIcon": "fa fa-folder-open",
          "collapsedIcon": "fa fa-folder",
          "isNodeNew": true,
          "iconColor": "black",
          "textColor": "black",
          "expandedIconDetail": "help-circle-outline",
          "collapsedIconDetail": "help-circle-outline",
          "isNodeEnabled": true,
          "parent": this.selectedFiles[0],
          "children": [],
          "QuickScanAnswerId": this.selectedFiles[0].QuickScanAnswerId,
          "DataTypeId": datatypeId,
          "HelpTextId": null,
          "isHidden": "0",
          "newNode": true
        }
        node["Description"] = node.label;
        if(!this.selectedFiles[0].children) {
          this.selectedFiles[0].children = [];
        }
        this.selectedFiles[0].children.push(node);
        this.selectedFiles[0].expanded = true;
        this.traverseParent(node)
        this.isNodeSelect = true;
        this.type = 'followquickscanquestion';
        this.selectedFiles[0] = node;
        this.breadcrumbType = this._commonService.getLocalTranslation('label-followUpQuestion');
        //this.save()
      }

      this.quickScanTree = [...this.quickScanTree];
      setTimeout(() => {
        this.inputElement.nativeElement.focus();
      }, 200);
    }else{

      let newNode = document.querySelector('.isNode-new');
      if (newNode) newNode.classList.remove("isNode-new");
      this.selectedSuggestionFiles[0].isNodeNew = false
      let node = {
        "label": this._commonService.getLocalTranslation('label-newSuggestion'),
          "QuickScanSuggestionId": uuid.v4(),
          "expandedIcon": "fa fa-folder-open",
          "collapsedIcon": "fa fa-folder",
          "iconColor":"black",
          "textColor":"black",
          "isNodeEnabled": true,
          "isNodeNew": true,
          "SuggestionType": '',
          "parent": this.selectedSuggestionFiles[0],
          "SupportText": this._commonService.getLocalTranslation('label-newSuggestion'),
          "expandedIconDetail":"information-circle",
          "collapsedIconDetail":"information-circle",
          "children":[]
      }

      this.selectedSuggestionFiles[0].children.push(node);
      this.selectedSuggestionFiles[0] = node;
      this.isSuggestionNodeSelect = true;
      this.suggestionTree = [...this.suggestionTree];
      setTimeout(() => {
        this.inputElement.nativeElement.focus();
      }, 200);

    }

  }

  deleteNode(event) {
    if(this.category == 'quickscan'){

      let deletedNode = this.selectedFiles[0].parent.children.filter(n => n.label == this.selectedFiles[0].label)
      if (deletedNode[0].type.toLowerCase() === 'quickscan') {
        this.deleteQuickScan(deletedNode[0].QuickScanId)
      }
      else if (deletedNode[0].type.toLowerCase() === 'quickscansection') {
        this.deleteQuickScanSection(deletedNode[0].QuickScanSectionId)
      }
      else if (deletedNode[0].type.toLowerCase() === 'quickscanquestion') {
        this.deleteQuickScanQuestion(deletedNode[0].QuickScanQuestionId)
      }
      else if (deletedNode[0].type.toLowerCase() === 'quickscananswers'){
        this.deleteQuickScanAnswer(deletedNode[0].QuickScanAnswerId)
      }
      else if (deletedNode[0].type.toLowerCase() === 'followquickscanquestion'){
        this.deleteQuickScanQuestion(deletedNode[0].QuickScanQuestionId)
      }
      // this.selectedFiles.parent.children = this.selectedFiles.parent.children.filter(n=> n.label != this.selectedFiles.label)
      // this.quickScanTree = [...this.quickScanTree]
    }else{
      let deletedNode = this.selectedSuggestionFiles[0].parent.children.filter(n => n.label == this.selectedSuggestionFiles[0].label)
      this.deleteSuggestion(deletedNode[0].QuickScanSuggestionId)
    }

  }


  traverse(root) {
  if(this.category == 'quickscan'){

    if (root.type.toLowerCase() == 'quickscan') {
      this.parentNodeLabel = root.label
    }
    if(root.type == 'QuickScan'){
      root.expanded = true;
    }

    root.isNodeEnabled = true;

    let children = root.children;
    for (let i = 0; i < children.length; i++) {
      let child = children[i];
      child.isNodeEnabled = true;
      if (child.children && child.children.length > 0) {
        this.traverse(child);
      }
    }
  }else{
    root.expanded = true;
    root.isNodeEnabled = true;
    if(root.children){

      let children = root.children;
      for (let i = 0; i < children.length; i++) {
        let child = children[i];
        child.isNodeEnabled = true;
        if (child.children && child.children.length > 0) {
          this.traverse(child);
        }
    }
 }

}
}




  traverseDisabledAnswer(root, isTrue) {
    if (isTrue) {
      root.expanded = false
      let children = root.children;
      for (let i = 0; i < children.length; i++) {
        let child = children[i];
        child.isNodeEnabled = false;
        child.expanded = false
      }
    } else {
      root.expanded = true;
      let children = root.children;
      for (let i = 0; i < children.length; i++) {
        let child = children[i];
        child.isNodeEnabled = true;
      }
    }

  }

  async onNodeSelect(event, selectedFiles) {
    if(event.node.children && event.node.children.length == 0){
      this.isChildPresent = false;
    } else {
      this.isChildPresent = true;
    }
    this.breadcrumbs = [];
    let newNode = document.querySelector('.isNode-new');
    if (newNode) newNode.classList.remove("isNode-new");
    this.type = event.node.type.toLowerCase();
    this.breadcrumbType = event.node.type
    this.traverseParent(event.node)
    this.isNodeSelect = true
    let id = null;
    if (this.type == 'quickscan') {
      id = event.node.QuickScanId
      this.breadcrumbType = this._commonService.getLocalTranslation('label-quickScans')
    } else if (this.type == 'quickscansection') {
      id = event.node.QuickScanSectionId;
      this.selectedFiles[0].isHidden = Number(this.selectedFiles[0].isHidden) ? true : false
      this.breadcrumbType = this._commonService.getLocalTranslation('label-quickScanSection')
    } else if (this.type == 'quickscanquestion') {
      id = event.node.QuickScanQuestionId
      this.breadcrumbType = this._commonService.getLocalTranslation('label-quickScanQuestion')
    } else if (this.type == 'quickscananswers'){
      id = event.node.QuickScanAnswerId
      this.breadcrumbType = this._commonService.getLocalTranslation('label-quickScanAnswer')
    } else {
      id = event.node.QuickScanAnswerId
      this.breadcrumbType = this._commonService.getLocalTranslation('label-followUpQuestion')
    }
    //let response = await this.getDetail(this.type, id);
    // if(Object.keys(this.selectedFiles[0].data).length === 0) {
    //   let response = await this.getDetail(this.type, id);
    //   this._commonService.dismiss();
    //   console.log(response);
    //   this.selectedFiles[0].data = response;
    // }

    setTimeout(() => {
      if (this.content) {
        this.content.getScrollElement().then(el => {
          if (el) {
            this.content.scrollToPoint(0, 0, 0);
          }
        });
      }
      this.inputElement.nativeElement.focus();
    }, 200);
  }

  async getDetail(type, id) {
    try {
      this._commonService.presentLoading()
      if (type == 'quickscan') {
        let res = await this._apiService.getQuickScanDetail(id)
        this.quickScan = {}
        this.quickScan = res.body
      }
      // else if (type == 'quickscansection') {

      //   let res = await this._apiService.getQuickScanSectionDetail(id)
      //   this.quickScanSection = {}
      //   this.quickScanSection = res.body;
      //   return res.body;
      // }

      // else if (this.type == 'quickscanquestion') {
      //   let res = await this._apiService.getQuickScanQuestionDetail(id)
      //   //this.quickScanQuestion = {}
      //   //this.quickScanQuestion = res.body;
      //   return res.body;
      // }

      // else {
      //   let res = await this._apiService.getQuickScanAnswerDetail(id)
      //   return res.body;
      //   //this.quickScanAnswer = {}
      //   //this.quickScanAnswer = res.body
      // }

      this._commonService.dismiss();

    } catch (error) {
      this._commonService.dismiss();
      this._commonService.log(error, this._commonService.ERROR);
    }
  }

  onDrop(event) {
    //this.selectedFiles = {}
    if(this.category == 'quickscan'){

      if(event.hasOwnProperty('dropIndex')){
        if (event.dragNode.parent.type == event.dropNode.parent.type){
          if(event.dropNode.parent.type == "QuickScan") {
            this.quickScanTree[0].isChildDropped = true;
          }
          if(event.dropNode.parent.type == "QuickScanSection") {
            if(event.dragNode.QuickScanSectionId != event.dropNode.QuickScanSectionId) {
              for(let item of event.dragNode.children) {
                item.NextQuickScanQuestion = [];
                item.isModified = true;
              }
            }
            event.dragNode.QuickScanSectionId = event.dropNode.QuickScanSectionId;
            let allNode = this._commonService.findAll(this.quickScanTree, 'quickscansection');
            let parent = allNode.find(x => x.QuickScanSectionId == event.dropNode.parent.QuickScanSectionId);
            parent.isChildDropped = true;

          }
          if(event.dropNode.parent.type == "QuickScanQuestion") {
            if(event.dragNode.QuickScanQuestionId != event.dropNode.QuickScanQuestionId) {
              event.dragNode.NextQuickScanQuestion = [];
            }
            event.dragNode.QuickScanQuestionId = event.dropNode.QuickScanQuestionId;
            let allNode = this._commonService.findAll(this.quickScanTree, 'quickscanquestion');
            let parent = allNode.find(x => x.QuickScanQuestionId == event.dropNode.parent.QuickScanQuestionId);
            parent.isChildDropped = true;
          }
          if(event.dropNode.parent.type == "QuickScanAnswers") {
            event.dragNode.QuickScanAnswerId = event.dropNode.QuickScanAnswerId;
            let allNode = this._commonService.findAll(this.quickScanTree, 'quickscananswers');
            let parent = allNode.find(x => x.QuickScanAnswerId == event.dropNode.parent.QuickScanAnswerId);
            parent.isChildDropped = true;
          }
          event.accept()
          this.dragNodeArray = []
        }
      } else {
        if(event.dragNode.type != event.dropNode.type) {
          if (event.dragNode.type == "QuickScanSection"){

          }

          if (event.dragNode.type == "QuickScanQuestion" && event.dropNode.type=="QuickScanSection"){
            event.dragNode.QuickScanSectionId = event.dropNode.QuickScanSectionId;
            event.accept();
            this.dragNodeArray = [];
            let allNode = this._commonService.findAll(this.quickScanTree, 'quickscansection');
            let parent = allNode.find(x => x.QuickScanSectionId == event.dragNode.QuickScanSectionId);
            parent.isChildDropped = true;
            for(let item of event.dragNode.children) {
              item.NextQuickScanQuestion = [];
              item.isModified = true;
            }
          }

          if (event.dragNode.type == "QuickScanAnswers" && event.dropNode.type=="QuickScanQuestion"){
            event.dragNode.QuickScanQuestionId = event.dropNode.QuickScanQuestionId;
            event.accept();
            this.dragNodeArray = [];
            let allNode = this._commonService.findAll(this.quickScanTree, 'quickscanquestion');
            let parent = allNode.find(x => x.QuickScanQuestionId == event.dragNode.QuickScanQuestionId);
            parent.isChildDropped = true;
            event.dragNode.NextQuickScanQuestion = [];
          }

          if (event.dragNode.type == "FollowQuickScanQuestion" && event.dropNode.type=="QuickScanAnswers"){
            event.dragNode.QuickScanAnswerId = event.dropNode.QuickScanAnswerId;
            event.accept();
            this.dragNodeArray = [];
            let allNode = this._commonService.findAll(this.quickScanTree, 'quickscananswers');
            let parent = allNode.find(x => x.QuickScanAnswerId == event.dragNode.QuickScanAnswerId);
            parent.isChildDropped = true
          }
        }
      }
    }else{
      if(event.hasOwnProperty('dropIndex')){
        if (event.dragNode.parent.type == event.dropNode.parent.type){
          event.accept();
        }
      }
    }

  }

  onQuestionChanged(event) {
    // this.quickScanAnswer.NextQuickScanQuestionId = event.length > 0 ? event.join(',') : []
    // console.log(this.quickScanAnswer.NextQuickScanQuestionId)
  }

  onSuggestionChanged(event) {
    //this.quickScanAnswer.QuickScanSuggestionId = event ? event : null
  }

  onSectionChanged(event) {
    //this.quickScanAnswer.QuickScanSectionId = event ? event : null

  }

  // onDataChanged(event) {
  //   this.addToList(this.selectedFiles[0]);
  // }

  // onHelpTextChanged(event) {
  //   this.addToList(this.selectedFiles[0]);
  // }

  // onResultChanged(event) {
  //   this.addToList(this.selectedFiles[0]);
  // }

  updateDescription() {
    if(this.category == 'quickscan'){

      if(this.type == "quickscan") {
        this.quickScanTree[0].label  = this.quickScan.Name;
      } else if(this.type == "quickscansection") {
        let section = this.sectionList.filter(x => x.QuickScanSectionId == this.selectedFiles[0].QuickScanSectionId);
        if(section.length > 0) {
          section[0].Description = this.selectedFiles[0].label;
        }

        // this.sectionList.sort((a, b) => {
        //   if (a.Description.toLowerCase() > b.Description.toLowerCase()) {
        //     return 1;
        // }
        // if (a.Description.toLowerCase() < b.Description.toLowerCase()) {
        //     return -1;
        // }
        // return 0;
        // })

      } else if(this.type == "quickscanquestion"){
        let question = this.questionList.filter(x => x.QuickScanQuestionId == this.selectedFiles[0].QuickScanQuestionId);
        if(question.length > 0) {
          question[0].Description = this.selectedFiles[0].Description;
        }

        this.questionList.sort((a, b) => {
          if (a.QuestionNumber > b.QuestionNumber) {
            return 1;
        }
        if (a.QuestionNumber < b.QuestionNumber) {
            return -1;
        }
        return 0;
        })
      }
    }else{
      let suggestion = this.suggestionTree[0].children.filter(x => x.QuickScanSuggestionId == this.selectedSuggestionFiles[0].QuickScanSuggestionId);
        if(suggestion.length > 0) {
          suggestion[0].SupportText = this.selectedSuggestionFiles[0].label;
        }
    }
  }
  helpText(){
    // console.log("The changes are");
    // this.selectedFiles[0].QuestionNumber = this.selectedFiles[0].QuestionNumber;
    if(this.selectedFiles[0].QuestionNumber==null){
    this.selectedFiles[0].label = this.selectedFiles[0].Description
    }else if(this.selectedFiles[0].Description==null){
      this.selectedFiles[0].label = this.selectedFiles[0].QuestionNumber
    }else{
      this.selectedFiles[0].label = this.selectedFiles[0].QuestionNumber ? this.selectedFiles[0].QuestionNumber + '. ' + this.selectedFiles[0].Description : this.selectedFiles[0].Description;
    }
  }

  // onDescriptionChanged() {
  //   this.selectedFiles[0].label  = this.selectedFiles[0].data.Description;
  //   this.selectedFiles[0].onChanged = true;
  // }

  // addToList(selectedNode) {
  //   if(selectedNode.type.toLowerCase() == "quickscansection") {

  //   }

  //   if(selectedNode.type.toLowerCase() == "quickscanquestion") {
  //     if(this.changedQuestions.length == 0) {
  //       this.changedQuestions.push(selectedNode.data);
  //     } else {
  //       let index = this.changedQuestions.findIndex((item, i) => {
  //         return item.QuickScanQuestionId    ==  selectedNode.QuickScanQuestionId
  //       });
  //       if(index != -1) {
  //         this.changedQuestions[index] = selectedNode.data;
  //       } else {
  //         this.changedQuestions.push(selectedNode.data);
  //       }
  //     }
  //   }

  //   if(selectedNode.type.toLowerCase() == "quickscananswers") {
  //     this.changedQuestions
  //   }

  //   if(selectedNode.type.toLowerCase() == "quickscan") {

  //   }
  // }

  traverseParent(root) {
    this.breadcrumbs.unshift(root.label);
    let parent = root.parent;
    if (parent) {
      this.breadcrumbs.unshift(parent.label)
      if (parent.parent) {
        this.traverseParent(parent.parent);
      }
    }

  }

  traverseFindNode(data) {
    for (const root of data) {
      if (root.parent) delete root.parent;
      this.tempData.push(root)

      if (root.children && root.children.length > 0) {
        this.traverseFindNode(root.children);
      }
    }
  }

  async getDataTypes() {

    try {

      let datatypes = await this._apiService.getDataTypes('', '', '', 1, 0);
      this.dataTypes = datatypes.body


    } catch (error) {
      this._commonService.dismiss()
      this._commonService.log(error, this._commonService.ERROR);
    }
  }

  async getQuestionList() {

    try {
      let question = await this._apiService.getQuickScanQuestionList(this.quickScanId, '', '', '', 1, 0);

      this.questionList = question.body

    } catch (error) {
      this._commonService.dismiss()
      this._commonService.log(error, this._commonService.ERROR);
    }
  }

  async getSuggestionList() {

    try {
      let suggestion = await this._apiService.getAnswerSuggestionList(this.quickScanId, '', '', '', 1, 0);

      this.suggestionList = suggestion.body

    } catch (error) {
      this._commonService.dismiss()
      this._commonService.log(error, this._commonService.ERROR);
    }
  }

  async getHelpTextList() {

    try {
      let helpText = await this._apiService.getHelpTextList('', '', '', 1, 0, 'Module_Quickscan');
      this.helpTextList = helpText.body
    } catch (error) {
      this._commonService.dismiss()
      this._commonService.log(error, this._commonService.ERROR);
    }
  }

  async getSectionList() {

    try {
      let section = await this._apiService.getAnswerSectionList(this.quickScanId, '', '', '', 1, 0);
      this.sectionList = section.body
    } catch (error) {
      this._commonService.dismiss()
      this._commonService.log(error, this._commonService.ERROR);
    }
  }

  async save() {
    this.submitted = true;
    if(this.category == 'quickscan'){
      this.changedSection = [];
      this.changedQuestions = [];
      this.changedAnswers = [];
      this.changedFollowupQuestions = [];
      let emptyDescription  = this.findFilter(this.quickScanTree,'label','');
      let emptyQuestion = this.findFilter(this.quickScanTree[0].children,'QuestionNumber','');
      let emptyQuestionDescription = this.findFilter(this.quickScanTree[0].children,'Description','');
      if(emptyDescription.length > 0) {
        this.selectedFiles[0] = emptyDescription[0];
        setTimeout(() => {
          let expandedClass = document.getElementsByClassName('ui-treenode-content-selected');
          if(expandedClass && expandedClass.length>0)
          {
            expandedClass[0].scrollIntoView({ behavior: "smooth", block: "center" })
          }

        }, 200);
        this.type = this.selectedFiles[0].type;
        if(this.type.toLowerCase() == 'quickscan' ) {
          this.breadcrumbType = this._commonService.getLocalTranslation('label-quickScans');
        } else if(this.type.toLowerCase() == 'quickscansection' ) {
          this.breadcrumbType = this._commonService.getLocalTranslation('label-quickScanSection');
        } else if(this.type.toLowerCase() == 'quickscanquestion' ) {
          this.breadcrumbType = this._commonService.getLocalTranslation('label-quickScanQuestion');
        } else if(this.type.toLowerCase() == 'quickscananswers' ) {
          this.breadcrumbType = this._commonService.getLocalTranslation('label-quickScanAnswer');
        }

          this.inputElement.nativeElement.focus();

        return;
      }
      if(emptyQuestion.length > 0) {
        this.selectedFiles[0] = emptyQuestion[0];
        setTimeout(() => {
          let expandedClass = document.getElementsByClassName('ui-treenode-content-selected');
          if(expandedClass && expandedClass.length>0)
          {
            expandedClass[0].scrollIntoView({ behavior: "smooth", block: "center" })
          }



        }, 200);
        this.type = this.selectedFiles[0].type;
        if(this.type.toLowerCase() == 'quickscan' ) {
          this.breadcrumbType = this._commonService.getLocalTranslation('label-quickScans');
        } else if(this.type.toLowerCase() == 'quickscansection' ) {
          this.breadcrumbType = this._commonService.getLocalTranslation('label-quickScanSection');
        } else if(this.type.toLowerCase() == 'quickscanquestion' ) {
          this.breadcrumbType = this._commonService.getLocalTranslation('label-quickScanQuestion');
        } else if(this.type.toLowerCase() == 'quickscananswers' ) {
          this.breadcrumbType = this._commonService.getLocalTranslation('label-quickScanAnswer');
        }


      await setTimeout(() => {
        this.myInput.setFocus();
      }, 100);

        return;
      }

      if(emptyQuestionDescription.length > 0) {
        this.selectedFiles[0] = emptyQuestionDescription[0];
        setTimeout(() => {
          let expandedClass = document.getElementsByClassName('ui-treenode-content-selected');
          if(expandedClass && expandedClass.length>0)
          {
            expandedClass[0].scrollIntoView({ behavior: "smooth", block: "center" })
          }



        }, 200);
        this.type = this.selectedFiles[0].type;
        if(this.type.toLowerCase() == 'quickscan' ) {
          this.breadcrumbType = this._commonService.getLocalTranslation('label-quickScans');
        } else if(this.type.toLowerCase() == 'quickscansection' ) {
          this.breadcrumbType = this._commonService.getLocalTranslation('label-quickScanSection');
        } else if(this.type.toLowerCase() == 'quickscanquestion' ) {
          this.breadcrumbType = this._commonService.getLocalTranslation('label-quickScanQuestion');
        } else if(this.type.toLowerCase() == 'quickscananswers' ) {
          this.breadcrumbType = this._commonService.getLocalTranslation('label-quickScanAnswer');
        }


      await setTimeout(() => {
        this.myInput.setFocus();
      }, 100);

        return;
      }
      let data = {
        QuickScanId: this.quickScanId ? this.quickScanId : null,
        Name: this.quickScan.Name,
        Description: this.quickScan.Description
      }
      this._apiService.putQuickScan(data, this.quickScanId);
      for(var i=0; i< this.quickScanTree[0].children.length;i++) {
        //if(this.quickScanTree[0].children)
        let quickScanSection = this.quickScanTree[0].children[i];
        if(quickScanSection.isModified || this.quickScanTree[0].isChildDropped || quickScanSection.newNode) {
          let data = {
            QuickScanSectionId: quickScanSection.QuickScanSectionId ? quickScanSection.QuickScanSectionId : null,
            QuickScanId: this.quickScanId ? this.quickScanId : null,
            Description: quickScanSection.label,
            LongDescription: quickScanSection.LongDescription,
            SortOrder: i+1,
            isHidden: quickScanSection.isHidden==true ? '1' : '0'
          }
          this.changedSection.push(data);
        }
        for(var j=0; j< quickScanSection.children.length; j++ ) {
          let quickScanQuestion = quickScanSection.children[j];
          let datatype = '';
          if(quickScanQuestion.DataTypeId) {
            datatype = this.dataTypes.find(dt => dt.DataTypeId === quickScanQuestion.DataTypeId).Name;
          }
          if((datatype == 'DataType_SelectList' || datatype == 'DataType_MultiSelect' || datatype == 'DataType_RadioGroup') && quickScanQuestion.children.length < 1) {
            let msg = this._commonService.getLocalTranslation('label-minimumOneAnswerRequiredIn') + '<br>' + quickScanQuestion.label;
            this.presentAlert(msg);
            return;
          }
          if(quickScanQuestion.isModified || quickScanSection.isChildDropped || quickScanQuestion.newNode) {
            let data = {
              QuickScanSectionId: quickScanQuestion.QuickScanSectionId ? quickScanQuestion.QuickScanSectionId : null,
              QuickScanQuestionId: quickScanQuestion.QuickScanQuestionId ? quickScanQuestion.QuickScanQuestionId: null,
              Description: quickScanQuestion.Description,
              DataTypeId: quickScanQuestion.DataTypeId,
              HelpTextId: quickScanQuestion.HelpTextId,
            QuestionNumber:quickScanQuestion.QuestionNumber?quickScanQuestion.QuestionNumber:null,
              SortOrder: j+1
            }
            this.changedQuestions.push(data);
          }
          for(var k=0; k< quickScanQuestion.children.length; k++) {
            let quickScanAnswer = quickScanQuestion.children[k];
            if(quickScanAnswer.isModified || quickScanQuestion.isChildDropped || quickScanAnswer.newNode || (quickScanAnswer.children && quickScanAnswer.children.length > 0 && quickScanAnswer.children[0].newNode)) {
              let data = {
                QuickScanAnswerId: quickScanAnswer.QuickScanAnswerId ? quickScanAnswer.QuickScanAnswerId : null,
                QuickScanQuestionId: quickScanAnswer.QuickScanQuestionId ? quickScanAnswer.QuickScanQuestionId : null,
                Description: quickScanAnswer.label,

                QuestionNumber:quickScanAnswer.QuestionNumber,

                SortOrder: k+1,
                QuickScanSuggestionId: quickScanAnswer.QuickScanSuggestionId ? quickScanAnswer.QuickScanSuggestionId : null,
                QuickScanSectionId: quickScanAnswer.QuickScanSectionId ? quickScanAnswer.QuickScanSectionId : null,
                QuickScanSuggestionDescription: quickScanAnswer.QuickScanSuggestionDescription ? quickScanAnswer.QuickScanSuggestionDescription : null,
                NextQuickScanQuestion: quickScanAnswer.NextQuickScanQuestion ? quickScanAnswer.NextQuickScanQuestion : null,
                ResultType: quickScanAnswer.ResultType ? quickScanAnswer.ResultType : null,
                ResultText: quickScanAnswer.ResultText ? quickScanAnswer.ResultText : null,
              }
              if(quickScanAnswer.children && quickScanAnswer.children.length > 0) {
                data['FollowQuickScanQuestionId'] = quickScanAnswer.children[0].QuickScanQuestionId;
              }
              this.changedAnswers.push(data);
            }
            for(var l =0; l < quickScanAnswer.children.length; l++) {
              let quickScanFollowupQuestion = quickScanAnswer.children[l];
              if(quickScanFollowupQuestion.isModified || quickScanAnswer.isChildDropped || quickScanFollowupQuestion.newNode) {
                let data = {
                  QuickScanSectionId: quickScanQuestion.QuickScanSectionId ? quickScanQuestion.QuickScanSectionId : null,
                  QuickScanAnswerId: quickScanFollowupQuestion.QuickScanAnswerId ? quickScanFollowupQuestion.QuickScanAnswerId : null,
                  QuickScanQuestionId: quickScanFollowupQuestion.QuickScanQuestionId ? quickScanFollowupQuestion.QuickScanQuestionId: null,
                  Description: quickScanFollowupQuestion.Description,
                  DataTypeId: quickScanFollowupQuestion.DataTypeId,
                  HelpTextId: quickScanFollowupQuestion.HelpTextId,
                  QuestionNumber:quickScanFollowupQuestion.QuestionNumber,
                  SortOrder: l+1
                }
                this.changedFollowupQuestions.push(data);
              }
            }
          }
        }
      }

      try {
        this._commonService.presentLoading();
        if(this.changedSection.length > 0) {
          let sectionRequest = await this._apiService.postQuickScanSection(this.changedSection);
        }

        if(this.changedQuestions.length > 0) {
          let questionRequest = await  this._apiService.postQuickScanQuestion(this.changedQuestions);
        }

        if(this.changedFollowupQuestions.length > 0) {
          let followupQuestionRequest = await  this._apiService.postQuickScanQuestion(this.changedFollowupQuestions);
        }

        if(this.changedAnswers.length > 0) {
          let answerRequest = await  this._apiService.postQuickScanAnswer(this.changedAnswers);
        }
        this.getSectionList();
        this.getQuestionList();
        this._commonService.showToast(this._commonService.getLocalTranslation('label-recordSaved'));
        this._commonService.dismiss();


    } catch (error) {
      this._commonService.dismiss()
    }
  }else{
    let emptyDescription  = this.findFilter(this.suggestionTree[0].children,'label','');
      if(emptyDescription.length > 0) {
        return
      }else{
     let changedSuggestion = []
      for(var i=0; i< this.suggestionTree[0].children.length;i++) {

        let suggestion = this.suggestionTree[0].children[i];
        let data = {
          QuickScanId: this.quickScanId,
          QuickScanSuggestionId: suggestion.QuickScanSuggestionId ? suggestion.QuickScanSuggestionId : null,
          ModuleId:  suggestion.ModuleId ? suggestion.ModuleId : null,
          SuggestionType : suggestion.SuggestionType ,
          SupportText: suggestion.SupportText,
          RefExternalId: suggestion.RefExternalId ? suggestion.RefExternalId : null,
          SortOrder: i+1
        }
        changedSuggestion.push(data);
      }
      try {
        this._commonService.presentLoading();
        if(changedSuggestion.length > 0) {
         let suggestionRequest = await this._apiService.postSuggestionTree(changedSuggestion);
        }
        this.getSuggestionList()
        this._commonService.showToast(this._commonService.getLocalTranslation('label-recordSaved'));
       this._commonService.dismiss()
      } catch (error) {
        this._commonService.dismiss()
      }
  }
}

  }

  deleteQuickScan(quickScanId) {
    this._commonService.presentAlertConfirm()
      .then(async (res) => {
        try {
          this._commonService.presentLoading();
          await this._apiService.deleteQuickScan(quickScanId);
          //this.selectedFiles = {}
          this._commonService.log(res, this._commonService.LOG);
          //this.getInfo()
          this._commonService.dismiss();
        } catch (error) {
          this._commonService.dismiss();
          this._commonService.log(error, this._commonService.ERROR);
        }
      })
      .catch((err) => {
        this._commonService.log(err, this._commonService.LOG);
      })
  }

  deleteQuickScanSection(quickScanSectionId) {
    this._commonService.presentAlertConfirm()
      .then(async (res) => {
        try {
          let index = this.selectedFiles[0].parent.children.findIndex((item, index) => {return item.QuickScanSectionId == this.selectedFiles[0].QuickScanSectionId});
          if(quickScanSectionId){
            this._commonService.presentLoading();
            await this._apiService.deleteQuickScanSection(quickScanSectionId);
            //this.selectedFiles = {}
            this.selectedFiles[0].parent.children.splice(index, 1);
            let i = this.sectionList.findIndex((x, index)=> x.QuickScanSectionId == quickScanSectionId);
            if(i) {
              this.sectionList.splice(i,1);
            }
            this._commonService.log(res, this._commonService.LOG);
            //this.getInfo()
            this._commonService.dismiss();
          } else {
            this.selectedFiles[0].parent.children.splice(index, 1);
          }

        } catch (error) {
          this._commonService.dismiss();
          this._commonService.log(error, this._commonService.ERROR);
        }
      })
      .catch((err) => {
        this._commonService.log(err, this._commonService.LOG);
      })
  }

  deleteQuickScanQuestion(quickScanQuestionId) {
    this._commonService.presentAlertConfirm()
      .then(async (res) => {
        try {
          let index = this.selectedFiles[0].parent.children.findIndex((item, index) => {return item.QuickScanQuestionId == this.selectedFiles[0].QuickScanQuestionId});
          if(quickScanQuestionId){
            this._commonService.presentLoading();
            await this._apiService.deleteQuickScanQuestion(quickScanQuestionId);
            //this.selectedFiles = {}
            this.selectedFiles[0].parent.children.splice(index, 1);
            let i = this.questionList.findIndex((x, index)=> x.QuickScanQuestionId == quickScanQuestionId);
            if(i) {
              this.questionList.splice(i,1);
            }
            this._commonService.log(res, this._commonService.LOG);
            //this.getInfo()
            this._commonService.dismiss();
          } else {
            this.selectedFiles[0].parent.children.splice(index, 1);
          }

        } catch (error) {
          this._commonService.dismiss();
          this._commonService.log(error, this._commonService.ERROR);
        }
      })
      .catch((err) => {
        this._commonService.log(err, this._commonService.LOG);
      })
  }

  deleteQuickScanAnswer(quickScanAnswerId) {
    this._commonService.presentAlertConfirm()
      .then(async (res) => {
        try {
          let index = this.selectedFiles[0].parent.children.findIndex((item, index) => {return item.QuickScanAnswerId == this.selectedFiles[0].QuickScanAnswerId});
          if(quickScanAnswerId){
            this._commonService.presentLoading();
            await this._apiService.deleteQuickScanAnswer(quickScanAnswerId);
            //this.selectedFiles = {}
            this.selectedFiles[0].parent.children.splice(index, 1);
            this._commonService.log(res, this._commonService.LOG);
            //this.getInfo()
            this._commonService.dismiss();
          } else {
            this.selectedFiles[0].parent.children.splice(index, 1);
          }

        } catch (error) {
          this._commonService.dismiss();
          this._commonService.log(error, this._commonService.ERROR);
        }
      })
      .catch((err) => {
        this._commonService.log(err, this._commonService.LOG);
      })
  }


  deleteSuggestion(suggestionId) {
    this._commonService.presentAlertConfirm()
      .then(async (res) => {
        try {
          let index = this.selectedSuggestionFiles[0].parent.children.findIndex((item, index) => {return item.QuickScanSuggestionId == this.selectedSuggestionFiles[0].QuickScanSuggestionId});
          if(suggestionId){
            this._commonService.presentLoading();
            await this._apiService.deleteSuggestions(suggestionId);
            //this.selectedFiles = {}
            this.selectedSuggestionFiles[0].parent.children.splice(index, 1);
            if(this.selectedSuggestionFiles[0].parent.children.length == 0){
              this.isSuggestionNodeSelect = false
            }
            this._commonService.log(res, this._commonService.LOG);
            //this.getInfo()
            this._commonService.dismiss();
          } else {
            this.selectedFiles[0].parent.children.splice(index, 1);
          }

        } catch (error) {
          this._commonService.dismiss();
          this._commonService.log(error, this._commonService.ERROR);
        }
      })
      .catch((err) => {
        this._commonService.log(err, this._commonService.LOG);
      })
  }


  async sortQuickScanSection(event) {

    let i = 0
    let parentId = ''
    this._commonService.presentLoading()
    try {
      event.dragNode.parent.children.forEach(element => {
        parentId = event.dragNode.parent.QuickScanId
        let data = {
          QuickScanSectionId: element.QuickScanSectionId,
          SortOrder: i++,
          Name: element.Description,
        }
        this.dragNodeArray.push(data)
      });
      let res = await this._apiService.sortQuickScanSection(this.dragNodeArray, parentId)

      this._commonService.dismiss()

    } catch (error) {
      this._commonService.dismiss();
      this._commonService.log(error, this._commonService.ERROR);
    }
  }

  async sortQuickScanQuestion(event) {
    let i = 0
    let parentId = ''
    this._commonService.presentLoading()
    try {
      event.dragNode.parent.children.forEach(element => {
        parentId = event.dragNode.parent.QuickScanSectionId
        let data = {
          QuickScanQuestionId: element.QuickScanQuestionId,
          SortOrder: i++,
          Name: element.Description,
        }
        this.dragNodeArray.push(data)
      });
      let res = await this._apiService.sortQuickScanQuestion(this.dragNodeArray, parentId)

      this._commonService.dismiss()

    } catch (error) {
      this._commonService.dismiss();
      this._commonService.log(error, this._commonService.ERROR);
    }
  }

  async sortQuickScanAnswer(event) {
    let i = 0
    let parentId = ''
    this._commonService.presentLoading()
    try {
      event.dragNode.parent.children.forEach(element => {
        parentId = event.dragNode.parent.QuickScanQuestionId
        let data = {
          QuickScanAnswerId: element.QuickScanAnswerId,
          SortOrder: i++,
          Name: element.Description,
        }
        this.dragNodeArray.push(data)
      });
      let res = await this._apiService.sortQuickScanAnswer(this.dragNodeArray, parentId)
      this._commonService.dismiss()

    } catch (error) {
      this._commonService.dismiss();
      this._commonService.log(error, this._commonService.ERROR);
    }
  }

  async saveBack() {
    await this.save();
    this.goBack();
  }

  goBack() {
    if(this.previousRoute){
      this.router.navigate(['maintenance/quickscan'], { replaceUrl: true });
    }else{
      this.router.navigate(['maintenance'], { replaceUrl: true });
    }

  }

  onActionChange(obj) {

    switch (obj.Action) {
      case "save":
        this.save();
        break;

      case "backToList":
        if(this.previousRoute){
          this.goBack();
        }
        break;
      case "backToMain":
        this.router.navigate(['maintenance'], { replaceUrl: true })
        break;
      case "back":
        this.goBack();
        break;
      case "saveReturn":
        this.saveBack()
        break;
        case "delete":
          this.delete();
          break;
    }


  }

  toggleTree() {
    if(this.category == 'quickscan'){

      this._commonService.presentLoading();
      this.treeExpand = !this.treeExpand;
      if(this.treeExpand == true){
        this.toggleQuickScanTooltip = this._commonService.getLocalTranslation('label-collapseAll')
      }else{
        this.toggleQuickScanTooltip = this._commonService.getLocalTranslation('label-expandAll')
      }

      setTimeout(() => {
        if (this.quickScanTree &&  this.treeExpand == true) {
          this.traverseToggleExpand(this.quickScanTree);
        }else{
          this.traverseToggleExpandSection(this.quickScanTree);
        }
        this._commonService.dismiss();
      }, 500);
    }else{
      this._commonService.presentLoading();
      this.treeSuggestionExpand = !this.treeSuggestionExpand;
      if(this.treeSuggestionExpand == true){
        this.toggleSuggestionTooltip = this._commonService.getLocalTranslation('label-collapseAll')
      }else{
        this.toggleSuggestionTooltip = this._commonService.getLocalTranslation('label-expandAll')
      }
      setTimeout(() => {
          this.traverseToggleExpandSuggestion(this.suggestionTree);
        this._commonService.dismiss();
      }, 500);
    }
  }

  traverseToggleExpand(quickscans) {
    for (const root of quickscans) {
      root.expanded = this.treeExpand;
      if (root.children && root.children.length > 0) {
        this.traverseToggleExpand(root.children);
      }
    }
  }

  traverseToggleExpandSuggestion(suggestionTree){
    for (const root of suggestionTree) {
      root.expanded = this.treeSuggestionExpand;
      if (root.children && root.children.length > 0) {
        this.traverseToggleExpand(root.children);
      }
    }
  }

  traverseToggleExpandSection(quickscans){
    for (const root of quickscans) {
      if(root.type == 'QuickScanQuestion' || root.type == 'QuickScanAnswers'){
        root.expanded = this.treeExpand;
      }

      if (root.children && root.children.length > 0) {
        this.traverseToggleExpand(root.children);
      }
    }
  }

  async presentAlert(msg) {
    const alert = await this.alertController.create({
      header: this._commonService.getLocalTranslation('label-alert'),
      message: msg,
      buttons: ['OK']
    });

    await alert.present();
  }

  disableQuestion() {
    if(this.selectedFiles[0].QuickScanSectionId) {
      this.selectedFiles[0].disableQuestion = true;
    } else {
      this.selectedFiles[0].disableQuestion = false;
    }
  }

  get filteredSectionList() {
    return this.sectionList.filter(x => {
      if(this.selectedFiles[0].parent) {
        return x.QuickScanSectionId != this.selectedFiles[0].parent.QuickScanSectionId
      }
    })
  }

  get filteredQuestionList() {
    return this.questionList.filter(x => {
      if(this.selectedFiles[0].parent) {
        return (x.QuickScanSectionId == this.selectedFiles[0].parent.QuickScanSectionId && x.QuickScanQuestionId!=this.selectedFiles[0].QuickScanQuestionId)
      }
    })
  }


  findFilter(arr,key,term) {
    if(this.category == 'quickscan'){
      if(key == 'label')
 {     var matches = [];
      if (!Array.isArray(arr)) return matches;

      arr.forEach(i => {
          if (i.label.trim() == term) {
              matches.push(i);
          } else {
              let childResults = this.findFilter(i.children,key,term);
              if (childResults.length)
              matches = [ ...matches, ...childResults];
          }
      })

      return matches;}
      else{
        if(key == 'QuestionNumber'){
          var matches = [];
          if (!Array.isArray(arr)) return matches;

          arr.forEach(k => {
            k.children.forEach(i=>{
              if (i.QuestionNumber == term || i.QuestionNumber==null ) {
                matches.push(i);
            } else {
                let childResults = this.findFilter(i.children,key,term);
                if (childResults.length)
                matches = [ ...matches, ...childResults];
            }
            })

          })

          return matches;
        }
      }
        if(key == 'Description'){
          var matches = [];
          if (!Array.isArray(arr)) return matches;

          arr.forEach(k => {
            k.children.forEach(i=>{
              if (i.Description.trim() == term || i.Description==null ) {
                matches.push(i);
            } else {
                let childResults = this.findFilter(i.children,key,term);
                if (childResults.length)
                matches = [ ...matches, ...childResults];
            }
            })

          })

          return matches;
        }

    }else{
      var matches = [];
      if (!Array.isArray(arr)) return matches;

      arr.forEach(i => {
          if (i.label.trim() == term || i.SuggestionType == term) {
              matches.push(i);
          }
      })

      return matches;
    }
  }


  async onSuggestionNodeSelect(event, selectedSuggestionFiles) {

    let newNode = document.querySelector('.isNode-new');
    if (newNode) newNode.classList.remove("isNode-new");

    if(!event.node.ModuleId){
      this.moduleName = '';
      //this.documentList = []
    }else{
      //this.documentList = [...this.originalModuleList]
      let temp = this.moduleList.find(f => f.guid == event.node.ModuleId);
      if(temp.name_systemtranslationcode == 'Module_FAQ') {
        this.moduleName = 'faq';
      } else if(temp.name_systemtranslationcode == 'Module_DocumentGenerator'){
        this.moduleName = 'document';
      } else if(temp.name_systemtranslationcode == 'Module_StandardDocument'){
        this.moduleName = 'standardDocument';
      }
    }

    if(!(event.node.type =='parent')){
      this.isSuggestionNodeSelect = true
    }else{
      this.isSuggestionNodeSelect = false
    }

    setTimeout(() => {
      this.inputElement.nativeElement.focus();
    }, 200);

  }



  async getSuggestionTree(){
   try {
     this.suggestionTree = []
     let res = await this._apiService.getSuggestionTree(this.quickScanId)
     this.suggestionTree = res.body

   } catch (error) {
    this._commonService.dismiss()
    this._commonService.log(error, this._commonService.ERROR);
   }
  }


  async getModuleList() {
    try {
      if(localStorage.moduleList) {
        this.moduleList = JSON.parse(localStorage.moduleList);
      } else {
        let res = await this._apiService.getModules('', '', '', 1, 0);
        this.moduleList = res.body
      }
    } catch (error) {
      this.moduleList = [];
      this._commonService.dismiss();
      this._commonService.log(error, this._commonService.ERROR);
    }
  }

  get filteredModuleList() {
    return this.moduleList.filter(x=> x.name_systemtranslationcode == "Module_FAQ" || x.name_systemtranslationcode == "Module_DocumentGenerator" || x.name_systemtranslationcode == "Module_StandardDocument")
  }



  onTabChange(event){

    if(event.detail.value=="suggestions"){
      this.suggestionTree.forEach(element => {
        this.traverse(element)
      })
    }
  }

 async onChangeModule(event){
   if(!event.value){
    this.moduleName = '';
   }else{
      let temp = this.moduleList.find(f => f.guid == event.value)
      if(temp.name_systemtranslationcode == 'Module_FAQ') {
        this.moduleName = 'faq';
      } else if(temp.name_systemtranslationcode == 'Module_DocumentGenerator'){
        this.moduleName = 'document';
      } else if(temp.name_systemtranslationcode == 'Module_StandardDocument'){
        this.moduleName = 'standardDocument';
      }
   }

  }

  async getFaq(){
    try {
      let res = await this._apiService.getFaqs('','','',1,0,0)
      this.faqList = res.body;
     } catch (error) {
      this._commonService.dismiss()
     }
  }

  async getDocument(){
    try {
      let res = await this._apiService.getDocumentTemplates('', '', '', 1, 0, 0, '')
      this.documentList = res.body;
     } catch (error) {
      this._commonService.dismiss()
     }
  }

  async getStandardDocument(){
    try {
      let res = await this._apiService.getStandardDocuments('', '', 1, 0, 0, '');
      this.standardDocumentList = res.body;
     } catch (error) {
      this._commonService.dismiss()
     }
  }

  delete() {
    this._commonService.presentAlertConfirm()
      .then(async (res) => {
        try {
          this._commonService.presentLoading();
          await this._apiService.deleteQuickScan(this.quickScanId);
          this._commonService.dismiss();
          this._commonService.log(res, this._commonService.LOG);
          this.goBack();
        } catch (error) {
          this._commonService.dismiss();
          this._commonService.log(error, this._commonService.ERROR);
        }
      })
      .catch((err) => {
        this._commonService.log(err, this._commonService.LOG);
      })
  }

}
